import { Button, KBD, TypographyDetail } from '@seen/ui'
import {
  IconArrowLeft,
  IconArrowRight,
  IconLayoutSidebar,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconReload,
} from '@tabler/icons-react'
import type { JSX } from 'react'
import { useNavigate } from 'react-router'
import { AppNavigationMenu } from '#src/components/app/AppNavigationMenu.tsx'
import { Sheet } from '#src/components/core/sheet/Sheet.tsx'
import { SheetContent } from '#src/components/core/sheet/SheetContent.tsx'
import { SheetTrigger } from '#src/components/core/sheet/SheetTrigger.tsx'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { useNavStore } from '#src/hooks/useNavStore.ts'

export function NavSheetButton(): JSX.Element {
  const navigate = useNavigate()

  const open = useNavStore((state) => state.open)
  const setOpen = useNavStore((state) => state.setOpen)

  const pinned = useNavStore((state) => state.pinned)
  const setPinned = useNavStore((state) => state.setPinned)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      {pinned && (
        <Button
          variant="ghost"
          size="icon"
          className="rounded-none pl-4 hover:bg-frame-hover hover:backdrop-brightness-100"
          onClick={() => setPinned(false)}
        >
          <IconLayoutSidebarLeftCollapse className="size-4" />
        </Button>
      )}
      {!pinned && (
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="rounded-none pl-4 hover:bg-frame-hover hover:backdrop-brightness-100"
            onMouseEnter={() => setOpen(true)}
          >
            <IconLayoutSidebar className="size-4" />
          </Button>
        </SheetTrigger>
      )}
      <SheetContent
        side="left"
        onMouseLeave={() => setOpen(false)}
        hideClose
        className="gap-0 bg-frame p-0 text-frame-foreground"
      >
        <div className="flex h-full flex-col gap-2">
          <div className="flex items-center border-b">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-none pl-4 hover:bg-frame-hover hover:backdrop-brightness-100"
              onClick={() => {
                setPinned(true)
                setOpen(false)
              }}
            >
              <IconLayoutSidebarLeftExpand className="size-4" />
            </Button>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => navigate(-1)}
                  className="rounded-none hover:bg-frame-hover hover:backdrop-brightness-100"
                >
                  <IconArrowLeft className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent className="flex items-center gap-2 px-2">
                <TypographyDetail className="text-muted-foreground">
                  Go back
                </TypographyDetail>
                <KBD>Esc</KBD>
              </TooltipContent>
            </Tooltip>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(1)}
              className="rounded-none hover:bg-frame-hover hover:backdrop-brightness-100"
            >
              <IconArrowRight className="size-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={location.reload}
              className="rounded-none hover:bg-frame-hover hover:backdrop-brightness-100"
            >
              <IconReload className="size-4" />
            </Button>
          </div>
          <AppNavigationMenu className="flex-1 pb-frame" />
        </div>
      </SheetContent>
    </Sheet>
  )
}
